const addNetwork = {
  approveButton: '.confirmation-footer__actions button.btn-primary',
  cancelButton: '.confirmation-footer__actions button.btn-secondary'
}

const switchNetwork = {
  switchNetworkButton: '.confirmation-footer__actions button.btn-primary',
  cancelButton: '.confirmation-footer__actions button.btn-secondary'
}

export default {
  addNetwork,
  switchNetwork
}
